export const GET_CATEGORIES: string = "GET_CATEGORIES";
export const SET_CATEGORIES: string = "SET_CATEGORIES";

export const GET_EDIT_CATEGORIES: string = "GET_EDIT_CATEGORIES";
export const SET_EDIT_CATEGORIES: string = "SET_EDIT_CATEGORIES";
export const SAVE_CATEGORIES: string = "SAVE_CATEGORIES";
